import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import Vue from "vue";
export const SET_COLLAPSE_PROFILE_BOX = "SET_COLLAPSE_PROFILE_BOX";
export const SET_DISMISS_MISSING_FILOGIX_DETAILS_BANNER = "SET_DISMISS_MISSING_FILOGIX_DETAILS_BANNER";
const mutations = {
  [SET_COLLAPSE_PROFILE_BOX]: (state, {
    username,
    collapseComponentName,
    isCollapsed
  }) => {
    Vue.set(state.collapseBoxes, "byId", _objectSpread(_objectSpread({}, state.collapseBoxes.byId || {}), {}, {
      [username]: _objectSpread(_objectSpread({}, state.collapseBoxes.byId[username] || {}), {}, {
        [collapseComponentName]: isCollapsed
      })
    }));
    if (!state.collapseBoxes.allIds.some(id => id === username)) state.collapseBoxes.allIds.push(username);
  },
  [SET_DISMISS_MISSING_FILOGIX_DETAILS_BANNER]: (state, {
    username,
    applicationId
  }) => {
    Vue.set(state.dismissMissingFilogixDetailsBanner, applicationId, _objectSpread(_objectSpread({}, state.dismissMissingFilogixDetailsBanner[applicationId]), {}, {
      [username]: true
    }));
  }
};
export default mutations;